import type { ExtensionInstance, Source, WidgetInstance } from '~/models';

type NestedKeyOf<ObjectType extends object> = {
  [Key in keyof ObjectType & (string | number)]: ObjectType[Key] extends object
    ? // @ts-ignore
      `${Key}` | `${Key}.${NestedKeyOf<ObjectType[Key]>}`
    : `${Key}`;
}[keyof ObjectType & (string | number)];

export function checkObjectPath<T extends object>(
  dottedString: NestedKeyOf<T>,
) {
  return dottedString;
}

type ExtensionInstanceObjectPath = NestedKeyOf<ExtensionInstance>;
export type SearchInstanceObjectPath = NestedKeyOf<WidgetInstance>;
export type InstanceObjectPath =
  | ExtensionInstanceObjectPath
  | SearchInstanceObjectPath;

export type SourceObjectPath = NestedKeyOf<Source>;
